module.exports = __webpack_public_path__ + "static/media/50.ee41e45.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/50.wav
// module id = vtHb
// module chunks = 0